import { render } from "./App.vue?vue&type=template&id=88404ef2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=88404ef2&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_861e304fb8ba8ab2c2aa266f6b3984bf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__